"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortedCampaignListTypeSchema = exports.CountryListingTypeSchema = exports.CampaignIdsListingTypeSchema = exports.AppIdsListingTypeSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
exports.AppIdsListingTypeSchema = (0, core_1.StrictObject)({
    appList: typebox_1.Type.Array(typebox_1.Type.Number()),
});
exports.CampaignIdsListingTypeSchema = (0, core_1.StrictObject)({
    campaignList: typebox_1.Type.Array(typebox_1.Type.Number()),
});
exports.CountryListingTypeSchema = (0, core_1.StrictObject)({
    countryList: typebox_1.Type.Array(core_1.CountrySchema),
});
exports.SortedCampaignListTypeSchema = (0, core_1.StrictObject)({
    countryList: typebox_1.Type.Record(typebox_1.Type.Number(), typebox_1.Type.Array(core_1.CountrySchema)),
    budgetRemainingList: typebox_1.Type.Record(typebox_1.Type.Number(), typebox_1.Type.Number()),
    appList: typebox_1.Type.Record(typebox_1.Type.Number(), typebox_1.Type.Number()),
    activeCampaignList: typebox_1.Type.Array(typebox_1.Type.Number()),
    storefrontList: typebox_1.Type.Record(typebox_1.Type.Number(), core_1.CountrySchema),
});
